module.exports = __webpack_public_path__ + "static/img/winnie_lai.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wmm/winnie_lai.jpg
// module id = JJjs
// module chunks = 0